// extracted by mini-css-extract-plugin
module.exports = {"planc":"_2elp8","item":"_21EiS"};